import React, { Component } from 'react';

import ReactDOM from 'react-dom';

class EditImagewithTextfield extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: this.props.question,
      correctanswer: this.props.correctanswer,
      subcategory: this.props.subcategory,
    };

    ////console.log("this.state.question")
    ////console.log(this.state.question)
    ////console.log(this.props.question)
    ////console.log(this.state.subcategory)
    ////console.log(this.state.question)

    //this.handleQuestionChange = this.handleQuestionChange.bind(this);
  }

  handleCorrectAnswerChange(event) {
    this.setState({ correctanswer: event.target.value });
    this.props.selectedanswer(
      this.state.subcategory,
      event.target.value,
      this.state.question,
      ['1', '2', '3', '4']
    );

    //this.props.selected(event.target.value,'1');
  }

  handleQuestionChange(event) {
    this.setState({ question: event.target.value });
    //this.props.selected(event.target.value,'1');

    ////console.log(this.state.subcategory)
    ////console.log(this.state.subcategory)

    this.props.selectedanswer(
      this.state.subcategory,
      this.state.correctanswer,
      event.target.value,
      ['1', '2', '3', '4']
    );
  }

  handlecategoryChange(event) {
    this.setState({ subcategory: event.target.value });
    //this.props.selectedquestion(event.target.value,'1');
    this.props.selectedanswer(
      event.target.value,
      this.state.correctanswer,
      this.state.question,
      ['1', '2', '3', '4']
    );
  }

  // selectedanswer=(answer,id) =>{

  //    //////console.log(answer)
  //   // ////console.log(id)

  //     this.props.selected(answer,id);

  // }

  deletequestion() {
    ////console.log("Let me delete the question")
  }

  render() {
    return (
      <div className="questionBox">
        <div className="questions">
          {this.props.questionnumber} : {this.state.subcategory}
        </div>
        <img className="photo" src={this.state.question} />

        {/* <div> ID: { this.props.id } </div> */}
        <table className="centertable">
          <tbody>
            <tr>
              <td>Question:</td>
              <td>
                <input
                  type="text"
                  spellCheck="false"
                  autoComplete="off"
                  id={this.props.id}
                  value={this.state.subcategory}
                  onChange={(e) => {
                    this.handlecategoryChange(e);
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>Image URL:</td>
              <td>
                <input
                  type="text"
                  spellCheck="false"
                  autoComplete="off"
                  id={this.props.id}
                  value={this.state.question}
                  onChange={(e) => {
                    this.handleQuestionChange(e);
                  }}
                />
              </td>
            </tr>
            <tr>
              <td>Answer:</td>
              <td>
                <input
                  spellCheck="false"
                  autoComplete="off"
                  type="text"
                  id={this.props.id}
                  value={this.state.correctanswer}
                  onChange={(e) => {
                    this.handleCorrectAnswerChange(e);
                  }}
                />
              </td>
            </tr>
            {/* <input type="button"  id={this.props.id} onClick = { this.deletequestion() } /> */}
          </tbody>
        </table>
      </div>
    );
  }
}

export default EditImagewithTextfield;
